import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ISODateTimeWithUTCType } from '@principle-theorem/shared';
import * as moment from 'moment-timezone';

@Component({
  selector: 'pr-echarts-chart-card',
  templateUrl: './echarts-chart-card.component.html',
  styleUrls: ['./echarts-chart-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, MatButtonModule, MatIconModule],
})
export class EchartsChartCardComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly loading = input<boolean>(false);
  readonly errorMessage = input<string>();
  readonly retryable = input<boolean>(true);
  readonly empty = input<boolean>(false);
  readonly emptyIcon = input<string>('inbox');
  readonly emptyText = input<string>('No data for this range');
  readonly fetchedAt = input<ISODateTimeWithUTCType>();
  readonly cacheHit = input<boolean>();
  readonly retry = output<void>();

  readonly cardTitleId = computed(
    () => `chart-card-title-${this.title().replace(/\s+/g, '-').toLowerCase()}`
  );

  readonly showCacheChip = computed(
    () => this.cacheHit() === true && this.fetchedAt() !== undefined
  );

  readonly formattedFetchedAt = computed(() => {
    const fetchedAt = this.fetchedAt();
    if (!fetchedAt) {
      return '';
    }
    const parsed = moment(fetchedAt);
    return parsed.isValid() ? parsed.format('h:mm A') : '';
  });
}
